import { Box, Text, Title, useMantineTheme } from '@mantine/core'
import { useTranslations } from 'next-intl'
import Head from 'next/head'
import React from 'react'
import Layout from '../components/layout'
import prerenderImportantLocales from '../utils/prerender_locales.js'

const TermsPrivacy = () => {
  const t = useTranslations('Terms')
  const theme = useMantineTheme()

  const TERMS_AND_CONDITIONS = [
    {
      title: t('registrationRequirements.title'),
      content: [t('registrationRequirements.content')],
      subSections: [
        {
          title: t('registrationRequirements.subSections.content.title'),
          content: t('registrationRequirements.subSections.content.content')
        },
        {
          title: t('registrationRequirements.subSections.participation.title'),
          content: t('registrationRequirements.subSections.participation.content')
        }
      ]
    },
    {
      title: t('usageOfPersonalData.title'),
      content: [
        t('usageOfPersonalData.content.0'),
        t('usageOfPersonalData.content.1')
      ]
    },
    {
      title: t('emailPolicy.title'),
      content: [t('emailPolicy.content')]
    },
    {
      title: t('personalInformationRegistration.title'),
      content: [
        t('personalInformationRegistration.content.0'),
        t('personalInformationRegistration.content.1')
      ]
    },
    {
      title: t('participationRules.title'),
      content: [t('participationRules.content')]
    },
    {
      title: t('intellectualProperty.title'),
      content: [t('intellectualProperty.content')]
    },
    {
      title: t('limitationOfLiability.title'),
      content: [t('limitationOfLiability.content')]
    },
    {
      title: t('changesToTerms.title'),
      content: [t('changesToTerms.content')]
    },
    {
      title: t('contact.title'),
      content: [t('contact.content')]
    }
  ]

  return (
    <>
      <Head>
        <title>Terms & Privacy - Stream Discover</title>
        <meta
          name="description"
          content="Stream Discover Terms and Privacy Policy"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Box
        mt={24}
        sx={{
          width: '80vw',
          margin: 'auto',
          maxWidth: '1366px',
          lineHeight: 1.6,
          [theme.fn.smallerThan('md')]: { width: '90vw' }
        }}
      >
        {TERMS_AND_CONDITIONS.map((section, index) => (
          <Box key={index} mt={32}>
            <Title order={2} mb={12}>
              {section.title}
            </Title>
            {section.content.map((paragraph, idx) => (
              <Text key={idx} mb={12}>
                {paragraph}
              </Text>
            ))}
            {section.subSections &&
              section.subSections.map((subSection, subIndex) => (
                <Box key={subIndex} ml={20} mt={12}>
                  <Title order={3} mb={8}>
                    {subSection.title}
                  </Title>
                  <Text>{subSection.content}</Text>
                </Box>
              ))}
          </Box>
        ))}
      </Box>
    </>
  )
}

TermsPrivacy.getLayout = function getLayout(page) {
  return (
    <Layout
      withAutocomplete
      showHero
      heroTitle="TERMS & PRIVACY"
      heroSubtitle=""
      pageName="Terms"
    >
      {page}
    </Layout>
  )
}

export async function getStaticProps({ locale }) {
  prerenderImportantLocales(locale)

  return {
    props: {
      messages: (await import(`../locales/${locale.split('-')[0]}/common.json`))
        .default
    }
  }
}

export default TermsPrivacy
